// extracted by mini-css-extract-plugin
export default {"orders_container":"Orders_orders_container__iBWzp"};